import { useState } from "react";
import { Lock, RefreshCcw } from "lucide-react";
import { C } from "../../theme/tokens";
import { TrialRenewalScreen } from "./TrialRenewalScreen";

/* Shown instead of a section's real content when the user doesn't have
   access to it — either the backend's accessible_sections whitelist
   doesn't include it, or the balance-under-$1 override has locked
   everything but the profile. */
export function LockedScreen({
  t,
  wide,
  reason,
  onGoProfile,
  trialRenewalStatus = "idle",
  trialRenewalError = null,
  onSubmitTrialRenewal,
  onResetTrialRenewal,
}) {
  const [view, setView] = useState("locked"); // "locked" | "renew"

  if (view === "renew") {
    return (
      <TrialRenewalScreen
        t={t}
        wide={wide}
        status={trialRenewalStatus}
        error={trialRenewalError}
        onSubmit={onSubmitTrialRenewal}
        onBack={() => {
          onResetTrialRenewal?.();
          setView("locked");
        }}
      />
    );
  }

  return (
    <div
      style={{
        minHeight: wide ? "60vh" : "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: wide ? 40 : 20,
      }}
    >
      <div style={{ width: "100%", maxWidth: 360, textAlign: "center" }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: C.panel1,
            border: `1px solid ${C.hairline}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}
        >
          <Lock size={24} color={C.mutedB} />
        </div>
        <div
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 700,
            fontSize: 19,
            color: C.primary,
            letterSpacing: "-0.01em",
          }}
        >
          {t.locked_title}
        </div>
        <p style={{ color: C.secondary, fontSize: 13.5, lineHeight: 1.55, marginTop: 8 }}>
          {reason === "trial_expired" ? t.locked_trial_expired_desc : reason === "balance" ? t.locked_balance_desc : t.locked_access_desc}
        </p>
        {reason === "balance" && (
          <button
            onClick={onGoProfile}
            style={{
              marginTop: 16,
              padding: "13px 20px",
              borderRadius: 12,
              border: "none",
              background: `linear-gradient(120deg, ${C.greenBright} 0%, ${C.green} 100%)`,
              color: "#0b0d13",
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            {t.locked_topup}
          </button>
        )}
        {/*
        {reason === "trial_expired" && (
          <button
            onClick={() => window.open("https://t.me/Jotrade_manager", "_blank", "noopener,noreferrer")}
            style={{
              marginTop: 16,
              padding: "13px 20px",
              borderRadius: 12,
              border: "none",
              background: `linear-gradient(120deg, ${C.greenBright} 0%, ${C.green} 100%)`,
              color: "#0b0d13",
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            {t.locked_trial_manager}
          </button>
        )}
        */}
        {/*
        {reason === "trial_expired" && (
          <button
            onClick={() => setView("renew")}
            style={{
              marginTop: 10,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              padding: "13px 20px",
              borderRadius: 12,
              border: `1px solid ${C.hairline}`,
              background: "transparent",
              color: C.primary,
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 600,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            <RefreshCcw size={16} />
            {t.locked_trial_renew_button}
          </button>
        )}
        */}
      </div>
    </div>
  );
}












